class CredentialGroup {
    constructor() {
        this.password = '';
        this.sshKey = '';
        this.osType = '';
        this._filterKey = 'name';
    }

    static fromRaw(raw) {
        let credentialGroup = new CredentialGroup();
        credentialGroup.uuid = raw.uuid;
        credentialGroup.name = raw.name;
        credentialGroup.username = raw.username;
        credentialGroup.password = raw.password;
        credentialGroup.sshKey = raw.sshKey;
        credentialGroup.privateKey = raw.privateKey;
        credentialGroup.subscriptionId = raw.subscriptionId;
        credentialGroup.download = raw.download;
        credentialGroup.protocol = raw.protocol;
        credentialGroup.authType = raw.authType;
        credentialGroup.port = raw.port;
        credentialGroup.winRmTransport = raw.winRmTransport;
        credentialGroup.hasPassword = raw.hasPassword;
        credentialGroup.hasPrivateKey = raw.hasPrivateKey;
        return credentialGroup;
    }

    toRaw() {
        return {
            id: this.uuid,
            name: this.name,
            username: this.username,
            password: this.password,
            sshKey: this.sshKey,
            subscriptionId: this.subscriptionId,
            port: this.port,
            protocol: this.protocol,
            authType: this.authType,
            privateKey: this.privateKey,
            privateKeyPassphrase: this.passphrase,
            winRmTransport: this.winRmTransport,
        };
    }
}

module.exports = CredentialGroup;



// WEBPACK FOOTER //
// ./src/azurebackup/model/CredentialGroup.js